// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ToastFlashController from "./toast_flash_controller"
application.register("toast-flash", ToastFlashController)

import ConditionalFieldController from "./conditional_field_controller"
application.register("conditional-field", ConditionalFieldController)
